module.exports = __webpack_public_path__ + "static/media/02-full.8fdb36b5.jpg";